import { Pipe, PipeTransform, inject } from '@angular/core';
import { PublicMultimediaDataSourceService } from '../services/public-multimedia-data-source.service';
import { MultimediaThumbnailVariant } from '../../shared/enums/multimedia-thumbnail-variant';
import { Guid } from '@web/utils';

@Pipe({
  name: 'publicShopFileThumbnailUrl',
})
export class PublicShopFileThumbnailUrlPipe implements PipeTransform {
  /* prettier-ignore */
  private readonly multimediaDataSource = inject(PublicMultimediaDataSourceService);

  public transform(
    id: Guid,
    variant: MultimediaThumbnailVariant = MultimediaThumbnailVariant.Mini,
  ): string {
    return this.multimediaDataSource.shopFileThumbnailUrl(id, variant);
  }
}
